import { useEffect, useState } from "react";

import {
  Container,
  Grid,
  Typography,
  Icon,
  IconButton,
  FormControlLabel,
  Radio,
  Button,
  TextField,
  Checkbox,
  Box,
} from "@material-ui/core";
import "./style.scss";
import { useFormik } from "formik";
import { Config, useFetchApi, Translator } from "@itarget/shared";
import { useSelector } from "react-redux";
import { Alert } from "@material-ui/lab";
import { ModalFullScreen } from "../ModalFullScreen";
import { useStyles } from "./styles"

const ModalQuestionsCourse = ({
  polls,
  canClosePoll = true,
  closeShow,
  secondsLeftQuiz,
  limitTimeQuiz,
  fetchQuestions = () => {},
  onEndQuizCallback,
}) => {
  const classesModal = useStyles();
  const isTypeTwoVideoPoll = Number(polls?.tipo) === 2;
  const allowClose = canClosePoll && Number(polls?.tipo) !== 2;
  const [value, setValue] = useState();
  const [valueOther, setValueOther] = useState();
  const [checkRadio, setCheckRadio] = useState();
  const [others, setOthers] = useState([]);
  const [index, setIndex] = useState(0);
  const selectedLang = useSelector((state) => state.language.lang);
  const user = useSelector((state) => state.auth.user);
  const currentQuestion = polls?.pergunta?.[index];
  const hasSingleOptionTypeTwoPoll =
    isTypeTwoVideoPoll &&
    currentQuestion?.tipo_resposta === 2 &&
    currentQuestion?.resposta?.length === 1;

  const { data: dataSendAnswers, fetchData: fetchSendAnswers } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/question`,
    "POST"
  );

  const secondsToHour = (seconds) => {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secondsRemaining = seconds % 60;

    var hoursFormatted = hours.toString().padStart(2, "0");
    var minutesFormatted = minutes.toString().padStart(2, "0");
    var secondsFormatted = secondsRemaining.toString().padStart(2, "0");

    return hoursFormatted + ":" + minutesFormatted + ":" + secondsFormatted;
  };

  useEffect(() => {
    if (dataSendAnswers) {
      closeShow();
      fetchQuestions();
    }
  }, [closeShow, dataSendAnswers]);

  useEffect(() => {
    limitTimeQuiz();
  }, []);

  const handleChange = (event) => {
    formik.setFieldValue(event.target.name, event.target.value);
    setValue(event.target.value);
  };

  const handleChangeOther = (event) => {
    formik.setFieldValue(event.target.name, event.target.value);
    setValueOther(event.target.value);
  };

  const handleChangeRadio = (event) => {
    if (checkRadio) {
      formik.setFieldValue(checkRadio, "");
    }
    formik.setFieldValue(event.target.name, event.target.value);
    setValue(event.target.value);
    setCheckRadio(event.target.value);
  };

  const handleChangeSelect = (event) => {
    setValue(event.target.value);
    formik.setFieldValue(event.target.value, event.target.value);
  };

  const onSubmit = () => {
    if (value || hasSingleOptionTypeTwoPoll) {
      nextQuestion();
    }
  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    onSubmit,
  });

  const nextQuestion = () => {
    if (polls.pergunta.length > index + 1) {
      setIndex((i) => i + 1);
      setValue();
      setCheckRadio();
    } else {
      confirmQuiz();
      onEndQuizCallback(polls);
    }
  };

  const confirmQuiz = () => {
    var respostas = [];
    const values = Object.entries(formik.values);
    for (let i = 0; i < values.length; i++) {
      if (
        values[i][1] !== "" &&
        parseInt(values[i][0]) === parseInt(values[i][1])
      ) {
        respostas.push({
          pessoa_id: user.data.id,
          resposta_id: values[i][0],
        });
      } else if (values[i][1] !== "") {
        respostas.push({
          pessoa_id: user.data.id,
          resposta_id: values[i][0],
          outros: values[i][1]?.outros ? values[i][1]?.outros : values[i][1],
        });
      }
    }

    if (hasSingleOptionTypeTwoPoll) {
      const onlyAnswer = currentQuestion?.resposta?.[0];
      const alreadyAdded = respostas.some(
        ({ resposta_id }) => parseInt(resposta_id) === onlyAnswer?.resposta_id
      );

      if (onlyAnswer && !alreadyAdded) {
        respostas.push({
          pessoa_id: user.data.id,
          resposta_id: onlyAnswer.resposta_id,
        });
      }
    }

    fetchSendAnswers(
      JSON.stringify({
        respostas,
      })
    );
  };

  const handleChangeCheckbox = (e) => {
    if (e.target.checked) {
      formik.setFieldValue(e.target.name, e.target.name);
      setValue(e.target.name);
    } else {
      formik.setFieldValue(e.target.name, "");
    }
  };

  const translation = {
    typeHere: Translator({ transRef: "translation.digite aqui" }),
    others: Translator({ transRef: "translation.Outros" }),
  };

  useEffect(() => {
    if (!polls?.pergunta || polls?.pergunta?.length < 1) {
      return;
    }
    let answersId = polls?.pergunta[index]?.resposta
      .filter((r) => r.resposta_outros == "S")
      .map((r) => r.resposta_id);
    let allAnswers = polls?.pergunta[index]?.resposta.map((r) => r.resposta_id);
    setOthers((others) => {
      return others.filter(
        (id) => !allAnswers.filter((id) => id != value).includes(id)
      );
    });
    if (answersId == value && !others.includes(value)) {
      setOthers((others) => {
        return [...others, parseInt(value)];
      });
    }
  }, [value]);
  return (
    <ModalFullScreen>
      <Container
        className={`${classesModal.modalContent} modal-questions-course ${
          isTypeTwoVideoPoll ? "type-two-quick-check" : ""
        }`}
      >
        <Container
          maxWidth={isTypeTwoVideoPoll ? "md" : false}
          className={
            isTypeTwoVideoPoll
              ? "type-two-quick-check-card"
              : "modal-questions-course-card"
          }
        >
          {!isTypeTwoVideoPoll && (
            <Grid container className="grid-header">
              <Grid item xs={12} md={12}>
                <Typography className="text-header">
                  <Translator
                    transRef={`translation.${
                      polls?.descricao || "Questionário"
                    }`}
                  />
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} className="header-actions">
                {secondsLeftQuiz > 0 && (
                  <Box display="flex" alignItems="center" marginRight={2}>
                    <Icon color="error" style={{ marginRight: 8 }}>timer</Icon>
                    <Typography variant="h6" color="error" style={{ fontWeight: 'bold' }}>
                      {secondsToHour(secondsLeftQuiz)}
                    </Typography>
                  </Box>
                )}
                {allowClose && (
                  <IconButton onClick={closeShow} className="icon-header">
                    <Icon>highlight_off</Icon>
                  </IconButton>
                )}
              </Grid>
            </Grid>
          )}

          <Grid
            className={`grid-complet ${
              isTypeTwoVideoPoll ? "grid-complet-type-two" : ""
            }`}
          >
            {!polls?.pergunta || polls?.pergunta?.length < 1 ? (
              <Typography variant="h6" align="center">
                <Translator transRef="translation.Nenhuma pergunta disponível." />
              </Typography>
            ) : (
              <>
                <Grid
                  className={`grid-description ${
                    isTypeTwoVideoPoll ? "grid-description-type-two" : ""
                  }`}
                >
                  {isTypeTwoVideoPoll && (
                    <Typography className="type-two-title">
                      <Translator
                        transRef={`translation.${
                          polls?.descricao || "Questionário"
                        }`}
                      />
                    </Typography>
                  )}
                  {polls?.pergunta?.length > 1 && (
                    <Typography className="question-title">
                      {index + 1} de {polls.pergunta && polls.pergunta.length}
                    </Typography>
                  )}
                  {polls.pergunta?.[index]?.descricao && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: polls.pergunta[index]?.descricao,
                      }}
                    />
                  )}
                </Grid>
                <form
                  onSubmit={formik.handleSubmit}
                  className={isTypeTwoVideoPoll ? "type-two-quick-check-form" : ""}
                >
                  {polls?.pergunta?.[index]?.resposta.map((row, i) => (
                    <div key={i} className="camps">
                      {polls?.pergunta?.[index]?.tipo_resposta === 1 && (
                        <TextField
                          id="multiline-flexible"
                          multiline
                          name={row.resposta_id}
                          onChange={handleChange}
                          variant="outlined"
                          label={
                            row.descricao ? row.descricao : translation?.typeHere
                          }
                          className="field-textarea"
                        />
                      )}
                      {polls?.pergunta?.[index]?.tipo_resposta === 2 &&
                        !hasSingleOptionTypeTwoPoll && (
                        <FormControlLabel
                          name={row.resposta_id}
                          control={<Radio />}
                          checked={parseInt(checkRadio) === row.resposta_id}
                          label={row.descricao}
                          value={row.resposta_id}
                          onChange={handleChangeRadio}
                        />
                      )}
                      {polls?.pergunta?.[index]?.tipo_resposta === 3 && (
                        <FormControlLabel
                          name={row.resposta_id}
                          control={<Checkbox />}
                          label={row.descricao}
                          onChange={handleChangeCheckbox}
                        />
                      )}
                      {row.resposta_outros == "S" &&
                        others?.includes(row.resposta_id) && (
                          <TextField
                            label={translation.others}
                            name={`${row.resposta_id}[outros]`}
                            onChange={handleChangeOther}
                          />
                        )}
                    </div>
                  ))}
                  {polls?.pergunta?.[index]?.tipo_resposta === 4 && (
                    <TextField select onChange={handleChangeSelect}>
                      {polls.pergunta &&
                        polls.pergunta[index].resposta.map((row, i) => (
                          <option key={i} value={row.resposta_id}>
                            {row.descricao}
                          </option>
                        ))}
                    </TextField>
                  )}
                  <Grid
                    className={`grid-btn ${
                      isTypeTwoVideoPoll ? "grid-btn-type-two" : ""
                    }`}
                  >
                    <Button className="btn-confirm" type="submit">
                      {hasSingleOptionTypeTwoPoll ? "Sim" : <Translator transRef="translation.Confirmar" />}
                    </Button>
                  </Grid>
                </form>
              </>
            )}
          </Grid>
        </Container>
      </Container>
    </ModalFullScreen>
  );
};

export default ModalQuestionsCourse;
